import { render, staticRenderFns } from "./branchesTable.vue?vue&type=template&id=a1abef54&scoped=true&"
import script from "./branchesTable.vue?vue&type=script&lang=js&"
export * from "./branchesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1abef54",
  null
  
)

export default component.exports